import {Component, HostListener, Input} from '@angular/core';
import {OnboardingPainelService} from '../onboarding-painel.service';
import {videoOnboarding} from './onboarding-videos';

interface Duvida { pergunta: string; resposta: string; }

const NOMES: Record<string, string> = {
  comecar: 'Primeiros passos', cardapio: 'Cardápio', loja: 'Como sua loja funciona', horarios: 'Horários',
  pagamento: 'Pagamento', receber: 'Onde você recebe os pedidos', impressora: 'Impressora', extensao: 'Extensão do WhatsApp',
  teste: 'Pedido de teste', pronto: 'Loja pronta'
};

const DUVIDAS: Record<string, Duvida[]> = {
  comecar: [
    {pergunta: 'Preciso fazer tudo agora?', resposta: 'Não. Cada passo leva poucos minutos e fica salvo. Volte quando quiser pelo menu Primeiros passos.'},
    {pergunta: 'Como ganho os R$ 25 de desconto?', resposta: 'Concluindo o pedido de teste antes de acabar o teste grátis. O desconto entra sozinho na primeira mensalidade.'},
    {pergunta: 'Esqueci a senha. E agora?', resposta: 'Você não precisa de senha: peça à Mia um novo link de acesso no WhatsApp.'}
  ],
  cardapio: [
    {pergunta: 'A IA errou um preço, e agora?', resposta: 'Corrija na lista de revisão, logo abaixo. O cliente só vê produto com preço.'},
    {pergunta: 'Meu cardápio tem tamanhos (P, M, G)', resposta: 'Produtos com tamanhos aparecem com o botão Ajustar: o preço de cada tamanho fica no editor do produto.'},
    {pergunta: 'Posso colocar foto depois?', resposta: 'Pode. Foto, descrição e adicionais ficam em Cardápio › Produtos, quando quiser.'}
  ],
  loja: [
    {pergunta: 'Cobro taxa diferente por bairro', resposta: 'Comece com uma taxa única. Depois, em Formas de entrega, dá para cobrar por bairro ou por distância.'},
    {pergunta: 'Não faço delivery', resposta: 'Desligue Entrega e deixe só Retirada no balcão.'},
    {pergunta: 'Pedido mínimo é obrigatório?', resposta: 'Não. Deixe em branco se não tiver.'}
  ],
  horarios: [
    {pergunta: 'Abro no almoço e à noite', resposta: 'Marque o turno principal agora. O segundo turno você acrescenta depois em Horários de funcionamento.'},
    {pergunta: 'Fecho depois da meia-noite', resposta: 'Coloque o horário de fechar menor que o de abrir (ex.: 18:00 até 01:00). A gente entende que vira a madrugada.'},
    {pergunta: 'Num feriado vou fechar', resposta: 'Use Pausas programadas, que aparece no menu depois do pedido de teste.'}
  ],
  pagamento: [
    {pergunta: 'Como o cliente paga no Pix?', resposta: 'Ele vê sua chave no fim do pedido, paga e manda o comprovante. Com o Pix online a confirmação é automática.'},
    {pergunta: 'Aceito vale-refeição?', resposta: 'Ligue a opção de vale-refeição na lista.'},
    {pergunta: 'Onde recebo o dinheiro do cartão?', resposta: 'Na sua maquininha, na entrega ou no balcão: o cartão aqui é pago como hoje.'}
  ],
  receber: [
    {pergunta: 'O som não tocou', resposta: 'Confira o volume e se o aparelho não está no silencioso. No celular, deixe a tela do painel aberta.'},
    {pergunta: 'Posso receber no celular e no computador?', resposta: 'Pode. Os dois tocam quando o painel estiver aberto.'},
    {pergunta: 'Preciso de impressora?', resposta: 'Não. O pedido aparece na tela. A impressora só ajuda a cozinha e o entregador.'}
  ],
  impressora: [
    {pergunta: 'A página de teste não saiu', resposta: 'Confira se a impressora está ligada, com papel, e se o QZ Tray está aberto (ícone perto do relógio do Windows).'},
    {pergunta: 'Minha impressora não aparece na lista', resposta: 'Ela precisa estar instalada no Windows. Imprima uma página de teste pelo Windows e tente de novo aqui.'},
    {pergunta: 'Minha impressora é Bluetooth', resposta: 'Fale com a gente pelo WhatsApp: ajudamos a ligar no computador.'}
  ],
  extensao: [
    {pergunta: 'Não uso o Chrome', resposta: 'A extensão funciona no Google Chrome e no Microsoft Edge, no computador.'},
    {pergunta: 'Ela pede para ler o QR do WhatsApp', resposta: 'É o WhatsApp Web normal: leia o QR com o celular da loja e deixe a aba aberta.'},
    {pergunta: 'Para que serve a extensão?', resposta: 'Para o cliente receber no WhatsApp cada passo do pedido: aceito, saiu, entregue.'}
  ],
  teste: [
    {pergunta: 'O pedido não chegou', resposta: 'Confira se a loja mostrou a faixa azul "Pedido de teste" e espere alguns segundos: a tela atualiza sozinha.'},
    {pergunta: 'O cliente recebe mensagem?', resposta: 'Neste teste, o cliente é você: assim você vê o que ele vai receber.'},
    {pergunta: 'Como apago o pedido de teste?', resposta: 'Não precisa. Ao concluir, ele é cancelado sozinho e não entra nas vendas.'}
  ]
};

/**
 * Botão Ajuda sempre à vista no onboarding: o vídeo do passo, as dúvidas comuns dele e "Falar com a Mia" no
 * WhatsApp (a mesma conversa em que a loja nasceu) com a mensagem de contexto pronta.
 */
@Component({
  selector: 'app-onb-ajuda',
  templateUrl: './onb-ajuda.component.html',
  styleUrls: ['./onb-ajuda.component.scss']
})
export class OnbAjudaComponent {
  @Input() passo = 'comecar';
  @Input() telefoneGestor: string | null = null;
  @Input() empresa: any = {};

  aberto = false;
  motivo = '';
  passoDaAjuda = 'comecar';
  duvidaAberta = -1;

  constructor(private onboarding: OnboardingPainelService) {}

  /** Chamado pelos passos quando algo falha: a mensagem já sai explicando o que aconteceu. */
  abra(motivo = '', passo = ''): void {
    this.motivo = motivo;
    this.passoDaAjuda = passo || this.passo;
    this.duvidaAberta = -1;
    this.aberto = true;
    this.onboarding.registre('AJUDA_ABERTA', this.passoDaAjuda + (motivo ? `: ${motivo}` : ''));
  }

  @HostListener('document:keydown.escape')
  feche(): void { this.aberto = false; }

  get nomePasso(): string { return NOMES[this.passoDaAjuda] || 'Painel'; }

  get duvidas(): Duvida[] { return DUVIDAS[this.passoDaAjuda] || DUVIDAS.comecar; }

  get temVideo(): boolean { return !!videoOnboarding(this.passoDaAjuda); }

  get mensagem(): string {
    const sub = String(this.empresa?.dominio || '');
    let texto = `Oi, Mia! Preciso de ajuda.\nLoja: ${this.empresa?.nome || ''}${sub ? ` (${sub})` : ''}\nOnde estou: ${this.nomePasso}`;
    if (this.motivo) texto += `\nO que aconteceu: ${this.motivo}`;
    return texto;
  }

  get linkWhatsapp(): string | null {
    const telefone = String(this.telefoneGestor || '').replace(/\D/g, '');
    return telefone ? `https://wa.me/${telefone}?text=${encodeURIComponent(this.mensagem)}` : null;
  }

  abriuWhatsapp(): void { this.onboarding.registre('AJUDA_WHATSAPP', this.passoDaAjuda); }

  alterneDuvida(i: number): void { this.duvidaAberta = this.duvidaAberta === i ? -1 : i; }
}
